import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { CartButton } from '@grandvisionhq/common';
import { FixedCta } from '@grandvisionhq/content';
import { PageLayout } from '@grandvisionhq/layout';
import { useFeatureToggles } from '@grandvisionhq/state';
import CmsComponentSlot from '../containers/Slot/Slot.js';
import CmsHeader from '../containers/Header/Header.js';
import CmsFooter from '../containers/Footer/Footer.js';
import { useGetCtaButtonComponent } from '../hooks/use-get-cta-button-component.js';

const defaultLayout = {
    header: true,
    footer: true,
    navigation: true,
    hasOnlyLogoInHeader: false
};
const CmsPageLayout = ({ children , layoutSettings ={} , renderCartButton =defaultRenderCartButton , renderWishlistMenuItem , useAlternativeLogoInFooter ,  })=>{
    const layout = swcHelpers.objectSpread({}, defaultLayout, layoutSettings);
    const { isWishlistEnabled  } = useFeatureToggles();
    const header = layout.header ? /*#__PURE__*/ React.createElement(CmsComponentSlot, {
        path: "header"
    }, /*#__PURE__*/ React.createElement(CmsHeader, {
        renderSiteNav: !layout.hasOnlyLogoInHeader && layout.navigation,
        hasOnlyLogo: layout.hasOnlyLogoInHeader,
        renderCartButton: renderCartButton,
        renderWishlistMenuItem: isWishlistEnabled ? renderWishlistMenuItem : undefined
    })) : null;
    // The pre-footer should only be rendered on pages that have a footer
    const preFooter = layout.footer ? /*#__PURE__*/ React.createElement(CmsComponentSlot, {
        path: "prefooter/shared-container"
    }) : null;
    const footer = layout.footer ? /*#__PURE__*/ React.createElement(CmsComponentSlot, {
        path: "footer"
    }, /*#__PURE__*/ React.createElement(CmsFooter, {
        useAlternativeLogoInFooter: useAlternativeLogoInFooter
    })) : null;
    const { contentBlock , color , variant  } = useGetCtaButtonComponent();
    // The post-footer-cta-button should only be rendered on pages that have the cta-button
    const fixedBottomBarContent = contentBlock ? /*#__PURE__*/ React.createElement(FixedCta, {
        buttonText: contentBlock.buttonText,
        color: color,
        variant: variant,
        newWindow: contentBlock.newWindow,
        icon: contentBlock.iconImage,
        url: contentBlock.url,
        description: contentBlock.description
    }) : null;
    return /*#__PURE__*/ React.createElement(PageLayout, {
        header: header,
        footer: footer,
        preFooter: preFooter,
        fixedBottomBarContent: fixedBottomBarContent,
        hasSiteNav: layout.navigation,
        hasOnlyLogoInHeader: layout.hasOnlyLogoInHeader
    }, children);
};
function defaultRenderCartButton(item) {
    return /*#__PURE__*/ React.createElement(CartButton, {
        key: item.label,
        href: item.link && item.link.href,
        label: item.label,
        className: "header-menu__icon"
    });
}
var CmsPageLayout$1 = CmsPageLayout;

export { CmsPageLayout, CmsPageLayout$1 as default };
//# sourceMappingURL=Page.js.map
